import { IThemeProps } from "component/theme";
import styled from "styled-components";
import { FormControlLabel, ListItem, List } from "@mui/material";
import Box from "component/layoutComponents/Box/Box";
import Typography from "../Typography";

export const StyledListItem = styled(List)`
  ${({ theme }) => `
    width: 100%;
    .MuiCheckbox-colorPrimary {
      color: ${theme.uptimeColors.grayScales.darkerGray};
    }
    .Mui-checked {
      color: ${theme.uptimeColors.mainTheme.primary} !important;
    }
    .MuiListItem-root {
      padding: 0px !important;
      cursor: pointer;
    }
    .MuiList-padding {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    .MuiList-root {
      padding-left: ${theme.uptimeSpace[8]}px;
    }

    .MuiListItemText-primary {
      padding: ${theme.uptimeSpace[4]}px 0 !important;
    }

  `}
`;

export const StyledShowMore = styled(ListItem)`
  ${({ theme }) => `
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: ${theme.uptimeSpace[5]}px;
      cursor: pointer;
      span {
        padding-left: ${theme.uptimeSpace[8]}px;
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        font-weight: 400;
        color: ${theme.colors.grayScale[9]};
      }
      svg {
        margin-right: ${theme.uptimeSpace[2]}px;
      }
  `}
`;

export const StyledShowLess = styled(ListItem)`
  ${({ theme }) => `
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: ${theme.uptimeSpace[5]}px;
      cursor: pointer;
      span {
        padding-left: ${theme.uptimeSpace[8]}px;
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        font-weight: 400;
        color: ${theme.colors.grayScale[9]};
      }
      svg {
        margin-right: ${theme.uptimeSpace[2]}px;
        transform: rotate(180deg);
      }
  `}
`;

export const StyledFormControlLabel = styled(FormControlLabel)(
  ({ theme }: IThemeProps) => `
      .MuiFormControlLabel-root {
        margin-right: 0px !important;
        margin-left: 0px !important;
      }
      .MuiFormControlLabel-label {
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
      }
      .MuiIconButton-root {
        padding: ${theme.uptimeSpace[4]}px !important;
      }
      .MuiIconButton-label {
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        > div {padding: ${theme.uptimeSpace[0]}px !important;}
      }
    `
);

export const FilterBox = styled(Box)`
  ${({ theme, background }) => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: ${background || theme.uptimeColors.grayScales.white};
    border-radius: 16px;
    padding: ${theme.uptimeSpace[8]}px !important;

  `}
`;

export const StyledListLabel = styled(List)`
  ${({ theme }) => `
      .MuiListItemText-primary {
        margin-left: -${theme.uptimeSpace[8]}px;
      }
  `}
`;

export const StyledItem = styled.li`
  ${({ theme }) => `
      .MuiDivider-root {
        width: 100%;
      }
  `}
`;

export const StyledBox = styled(Box)`
`;

export const StyledLabel = styled(Typography)(({ theme }) => `
  span {
    color: ${theme.uptimeColors.grayScales.darkerGray};
  }
`);

export const StyledException = styled(Box)<{ isCheckException: boolean }>`
  ${({ theme, isCheckException }) => `
      padding: ${theme.uptimeSpace[5]}px 0 ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[8]}px;
      background: #E6F3FA;
      color: #013654;
      margin-bottom: ${isCheckException ? 0 : theme.uptimeSpace[8]}px;
      width: 100%;
  `}
`;